import { Grid } from '@mui/material';
import BoxDrawer from 'components/BoxDrawer';
import MuiRegularButton from 'components/MuiExtras/Button/MuiRegularButton';
import MuiPaper from 'components/MuiExtras/MuiPaper';
import TextFieldCounter from 'components/TextFieldCounter';
import * as React from 'react';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    text: string;
}

interface IProps {
    title: string;
    confirmText: string;
    removeText?: string;
    placeHolder?: string;
    maxLength: number;
    rows: number;
    value?: string;
    inputOptional?: boolean;
    onAccept: (text: string) => void;
    onRemove?: () => void;
    onCancel: () => void;
}

type Props = IProps;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////


class DrawerTextInput extends React.PureComponent<Props, IState> {
    constructor(props: Props) {
        super(props);
        this.state = {
            text: props.value || ""
        };
    }


    public render() {
        const { title, confirmText, removeText, placeHolder, maxLength, rows, inputOptional, onAccept, onRemove, onCancel } = this.props;
        return (
            <BoxDrawer
                open
                title={title}
                onClose={onCancel}
            >
                <MuiPaper dense elevation={0}>

                    <TextFieldCounter
                        autoFocus
                        fullWidth
                        multiline
                        placeholder={placeHolder}
                        rows={rows}
                        maxLength={maxLength}
                        value={this.state.text}
                        onChange={
                            (text) => {
                                this.setState({ text });
                            }
                        }
                    />

                    <Grid container justifyContent="center" alignItems="center" spacing={1}>
                        <Grid item>
                            <MuiRegularButton
                                width="large"
                                disabled={inputOptional === false && this.state.text.length == 0}
                                color="success"
                                onClick={() => onAccept(this.state.text)}
                            >
                                {confirmText}
                            </MuiRegularButton>
                        </Grid>
                        {
                            removeText && onRemove &&
                            <Grid item>
                                <MuiRegularButton
                                    width="large"
                                    color="error"
                                    onClick={() => onRemove()}
                                >
                                    {removeText}
                                </MuiRegularButton>
                            </Grid>
                        }
                    </Grid>
                </MuiPaper>
            </BoxDrawer >
        );
    }
}

export default DrawerTextInput;